import * as React from "react";
import {
  makeStyles,
  Theme,
  createStyles,
  TextField,
  InputAdornment,
  TextFieldProps,
} from "@material-ui/core";
import EditIcon from "@material-ui/icons/Edit";

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      "display": "flex",

      "& .MuiFormControl-root": {
        "minWidth": 125,
        background: theme.palette.type == "dark" ? 'transparent' : "#FFF",
        "margin": theme.spacing(0, 0.5),
        "flex": 1,

        "& legend": {
          maxWidth: 0,
        },

        "& .MuiOutlinedInput-input": {
          padding: theme.spacing(1, 4, 1, 1),
        },

        // replace default size of select
        "& .MuiInputLabel-outlined": {
          transform: "translate(14px, 10px) scale(1)",
        },

        // refixes transition animation on select
        "& .MuiInputLabel-outlined.MuiInputLabel-shrink": {
          transform: "translate(0px, -12px) scale(0.75)",
          background: "transparent",
          borderTop: "unset",
        },

        // change background color on hover of native select option
        "& option:hover": {
          backgroundColor: theme.palette.primary.main,
        },
      },

      "& svg": {
        color: theme.customPalette.svg.lightgrey,
      },
    },
  })
);

type SimpleTextFieldProps = {
  value?: string;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  handleChange?: (e: React.ChangeEvent<{ value: string }>) => void;
} & TextFieldProps;

function SimpleTextField({ value, handleChange, ...others }: SimpleTextFieldProps) {
  const classes = useStyles();

  return (
    <div className={classes.root}>
      <TextField
        autoComplete="off"
        value={value}
        onChange={handleChange}
        variant="outlined"
        InputProps={{
          endAdornment: (
            <InputAdornment position="end">
              <EditIcon />
            </InputAdornment>
          ),
        }}
        {...others}
      />
    </div>
  );
}

export default SimpleTextField;
